export const isEmptyText = value => {
    return value === null || value === undefined || value === '';
};
